<footer class="site-footer">
  <div class="site-footer__inner">

    <!-- ── Newsletter ──────────────────────────────────────────── -->
    <div class="footer-newsletter">
      <h2 class="footer-newsletter__title">{{ 'footer.newsletter.title' | translate }}</h2>
      <p class="footer-newsletter__description">
        {{ 'footer.newsletter.description' | translate }}
      </p>

      <form [formGroup]="newsletterForm" (ngSubmit)="submitNewsletter()" class="footer-newsletter__form" novalidate>
        <label class="visually-hidden" for="newsletter-email">{{ 'footer.newsletter.emailLabel' | translate }}</label>
        <input
          id="newsletter-email"
          type="email"
          class="form-control footer-newsletter__input"
          [placeholder]="'footer.newsletter.emailPlaceholder' | translate"
          formControlName="email"
        />
        @if (newsletterForm.get('email')?.touched && newsletterForm.get('email')?.invalid) {
          <p class="footer-newsletter__error">{{ 'footer.newsletter.emailError' | translate }}</p>
        }

        <label
          for="newsletter-consent"
          class="footer-newsletter__consent"
          [class.footer-newsletter__consent--invalid]="newsletterForm.get('acceptTerms')?.touched && newsletterForm.get('acceptTerms')?.invalid"
          [class.footer-newsletter__consent--shake]="consentShake()"
        >
          <span class="footer-newsletter__consent-box">
            <input id="newsletter-consent" type="checkbox" formControlName="acceptTerms" />
            <span class="footer-newsletter__consent-check mdi mdi-check" aria-hidden="true"></span>
          </span>
          <span class="footer-newsletter__consent-text">
            {{ 'footer.newsletter.consentPrefix' | translate }}
            <a routerLink="/privacy-policy" class="footer-newsletter__consent-link" (click)="$event.stopPropagation()">{{ 'footer.newsletter.consentLink' | translate }}</a>
          </span>
        </label>
        @if (newsletterForm.get('acceptTerms')?.touched && newsletterForm.get('acceptTerms')?.invalid) {
          <p class="footer-newsletter__error">{{ 'footer.newsletter.consentError' | translate }}</p>
        }

        <button type="submit" class="btn btn-primary footer-newsletter__submit" [disabled]="submitting()">
          @if (submitting()) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          } @else {
            {{ 'footer.newsletter.submit' | translate }}
          }
        </button>
      </form>
    </div>

    <!-- ── Link sections ───────────────────────────────────────── -->
    <div class="footer-sections">
      @for (section of footerSections; track section.titleKey) {
        <div class="footer-section">
          <h3 class="footer-section__title">{{ section.titleKey | translate }}</h3>
          <ul class="footer-section__links">
            @for (link of section.links; track link.key) {
              <li><a [routerLink]="link.route">{{ link.key | translate }}</a></li>
            }
          </ul>
        </div>
      }
    </div>

  </div>

  <!-- ── Bottom bar ────────────────────────────────────────────── -->
  <div class="footer-bottom">
    <div class="footer-bottom__inner">
      <div class="footer-bottom__copyright">
        <span class="mdi mdi-copyright" aria-hidden="true"></span>
        <span>{{ currentYear }} {{ 'footer.copyright' | translate }}</span>
      </div>
      <div class="footer-bottom__socials">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'footer.social.facebook' | translate">
          <span class="mdi mdi-facebook" aria-hidden="true"></span>
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'footer.social.instagram' | translate">
          <span class="mdi mdi-instagram" aria-hidden="true"></span>
        </a>
        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'footer.social.youtube' | translate">
          <span class="mdi mdi-youtube" aria-hidden="true"></span>
        </a>
      </div>
    </div>
  </div>
</footer>
